import React from 'react'
import PropTypes from 'prop-types';
import { Button } from '@leverege/ui-elements'
import classnames from 'classnames'
import style from './valuecard.css';

export default class ValueCardGroup extends React.Component {
  
  static propTypes = {
    style : PropTypes.string,
    name : PropTypes.string,
    icon : PropTypes.string,
    fontIcon : PropTypes.string
    // component : PropTypes.or( PropTypes.component, PropTypes.string )
  }

  render() {
    const { name, icon, fontIcon, isRoot, showDelete, onDelete } = this.props

    const vName = <div className={classnames( style.groupName, isRoot ? style.rootName : '' )}>{name || '/'}</div>
    const vIcon = icon == null ? ( fontIcon == null ? null : <div className={style.fontIcon}><i className={fontIcon} /></div> ) : 
      ( typeof icon === 'string' ? <div className={style.icon} style={{ backgroundImage : `url(${icon})` }} /> : null )

    let header = null
    if ( vName || vIcon ) {
      header = (
        <div className={classnames( style.horizontal, style.style1, style.selfLeft, style.groupHeader )}>
          {vIcon}
          {vName}
          {showDelete ? <Button variant="deleteLink|link" title="delete data group" className={style.delete} onClick={onDelete} icon="fa fa-times"/> : null}
        </div>
      )
    }
    return (
      <div className={classnames( style.vertical, style.group, this.props.className, header ? '' : style.noBorder )}>
        {header}
        {header ? <div className={style.groupHeaderLine} /> : null}
        <div className={classnames( style.horizontal )}>
          {this.props.children}
        </div>
      </div>
    )
  }
}
